export const sidebarEmployeeOptionsEnum = {
    'company': 'company',
    'company/update-data': 'company',
    'zones': 'zones',
    'zones/single-zone-details': 'zones',
    'zones/show-devices': 'zones',
    'zones/authmodal': 'zones',
    'zones/update-zone': 'zones',
    'zones/create-device': 'zones',
    'zones/update-device': 'zones',
    'events': 'events',
    'events/normal-events': 'events',
    'events/incomming-envent-detail': 'events',
    'event-restriction': 'events',
    'all-employees': 'employees',
    'all-employees/employee-Detail': 'employees',
    'all-employees/add-employee': 'employees',
    'all-employees/update-employee': 'employees',
    'all-employees/uploademployeefile': 'employees',
    'all-employees/employee-docs': 'employees',
    'all-employees/employee-docs-complete': 'employees',
    'user-restriction': 'employees',
    'company/headers': 'employees',
    'vehicle-fleet': 'vehicles',
    'vehicle-fleet/create-vehicle': 'vehicles',
    'vehicle-fleet/vehicle-detail': 'vehicles',
    'vehicle-fleet/update-vehicle': 'vehicles',
    'access': 'access',
    'contractors': 'contractor',
    'contractors/create-contract': 'contractor',
    'contractors/add-contractor': 'contractor',
    'contractors/update-contractor': 'contractor',
    'contractors/employee-contractor-details': 'contractor',
    'contractors/contractor-approve-document': 'contractor',
    'contractors/upload-contractor': 'contractor',
    'contractors/contractor-details': 'contractor',
    'contractors/contractor-detail': 'contractor',
    'contractors/vehicle-detail': 'contractor',
    'contractors/vehicleDetail': 'contractor',
    'contractors/update-contract': 'contractor',
    'contractors/employeeDetail': 'contractor',
    'suppliers': 'provider',
    'suppliers/create-order': 'provider',
    'suppliers/upload-contractor': 'provider',
    'suppliers/order-details': 'provider',
    'suppliers/vehicle-detail': 'provider',
    'suppliers/add-suppliers': 'provider',
    'suppliers/update-suppliers': 'provider',
    'suppliers/employee-suppliers-details': 'provider',
    'suppliers/upload-supplier': 'provider',
    'suppliers/suppliers-detail-page': 'provider',
    'attendance': 'payroll',
    'attendance/manage-attendence': 'payroll',
    'attendance/email-setting': 'emailSetting',
    'backup': 'backup',
    'departments': 'departments',
    'company/workshift-panel': 'workshift',
    'company/roles-panel': 'previlageSetting',
    'company/add-update-role': 'previlageSetting',
    'company/add-new-role': 'previlageSetting',
    'company/onboarding': 'onBoarding',
    'company/document-panel': 'userDocument',
    'company/vehicle-doc-panel': 'vehicleDocument',
    'devices': 'devices',
    'devices/create': 'devices',
    'devices/update': 'devices',
    'devices/configuration': 'devices',
    'cards': 'cards',
    'card-designer': 'card_designer',
    'card-designer/create-template': 'card_designer',
    'graphs': 'graphs',
    'dining': 'dining',
    'hard_delete': 'hard_delete',
    'logs': 'logs',
    'controller': 'controller',
    'controller/create-controller': 'controller',
    'sios': 'sios',
    'readers': 'readers',
    'work-office': 'homeoffice',
    'guard': 'guard',
    'guards': 'guards',
    'guards/create': 'guards',
    'guards/update': 'guards',
    'guards/zone-access': 'guards',
    'profile': 'profile',
};
